(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2521],{

/***/ 39212:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about",
      function () {
        return __webpack_require__(38792);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 38792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ about; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/component/home/renewal/main/pc/MainFooter.tsx
var MainFooter = __webpack_require__(62579);
// EXTERNAL MODULE: ./src/component/home/renewal/main/pc/MainGnb.tsx
var MainGnb = __webpack_require__(9561);
// EXTERNAL MODULE: ./src/component/home/renewal/main/pc/MainLayout.tsx
var MainLayout = __webpack_require__(63286);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 3 modules
var emotion_styled_browser_esm = __webpack_require__(77366);
// EXTERNAL MODULE: ./src/component/base/WebpImage.tsx
var WebpImage = __webpack_require__(76445);
// EXTERNAL MODULE: ./src/ruix/index.ts + 22 modules
var ruix = __webpack_require__(9869);
;// CONCATENATED MODULE: ./src/component/home/renewal/about/AboutContents.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	color: var(--card-bg);\n	font-family: Pretendard;\n	font-size: 40px;\n	font-style: normal;\n	font-weight: 800;\n	line-height: 116%; /* 46.4px */\n	letter-spacing: -1.6px;\n	margin: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-family: Pretendard;\n	font-size: 72px;\n	font-style: normal;\n	font-weight: 800;\n	line-height: 116%; /* 83.52px */\n	letter-spacing: -2.88px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	color: var(--desc-gray);\n	font-family: Pretendard;\n	font-size: 20px;\n	font-style: normal;\n	font-weight: 500;\n	line-height: 150%; /* 30px */\n	letter-spacing: -0.8px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	color: var(--desc-gray);\n	font-family: Pretendard;\n	font-size: 24px;\n	font-style: normal;\n	font-weight: 700;\n	line-height: 150%; /* 36px */\n	letter-spacing: -0.96px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	color: var(--card-bg);\n	font-family: Pretendard;\n	font-size: 40px;\n	font-style: normal;\n	font-weight: 700;\n	line-height: 130%; /* 52px */\n	letter-spacing: -1.2px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	color: var(--card-bg);\n	font-family: Pretendard;\n	font-size: 40px;\n	font-style: normal;\n	font-weight: 800;\n	line-height: 120%; /* 48px */\n	letter-spacing: -1.6px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 100%;\n	max-width: 1024px;\n	padding: 0 24px;\n	position: relative;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	gap: 80px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 100%;\n	height: 4px;\n	flex-shrink: 0;\n	background: #f8f9fb;\n	position: absolute;\n	left: 0;\n	top: 6px;\n	z-index: 0;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 244px;\n	gap: 12px;\n\n	picture {\n		z-index: 1;\n	}\n\n	.year {\n		color: var(--card-bg);\n		font-family: Pretendard;\n		font-size: 32px;\n		font-style: normal;\n		font-weight: 800;\n		line-height: 130%; /* 41.6px */\n		letter-spacing: -1.28px;\n	}\n\n	.month {\n		color: var(--card-bg);\n		font-family: Pretendard;\n		font-size: 20px;\n		font-style: normal;\n		font-weight: 700;\n		line-height: 150%; /* 30px */\n		letter-spacing: -0.8px;\n		padding-right: 4px;\n	}\n\n	.title {\n		color: var(--desc-gray);\n		font-family: Pretendard;\n		font-size: 20px;\n		font-style: normal;\n		font-weight: 500;\n		line-height: 150%;\n		letter-spacing: -0.8px;\n	}\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	width: 320px;\n	padding: 40px 20px;\n	flex-direction: column;\n	align-items: flex-start;\n	gap: 10px;\n	border-radius: 4px;\n	background: #f8f9fb;\n\n	.title {\n		color: var(--desc-gray);\n		text-align: center;\n		font-family: Pretendard;\n		font-size: 24px;\n		font-style: normal;\n		font-weight: 700;\n		line-height: 150%; /* 36px */\n		letter-spacing: -0.96px;\n		width: 100%;\n	}\n\n	.num {\n		color: var(--card-bg);\n		font-family: Pretendard;\n		font-size: 48px;\n		font-style: normal;\n		font-weight: 800;\n		line-height: 116%; /* 55.68px */\n		letter-spacing: -1.92px;\n	}\n\n	.numstr {\n		color: var(--card-bg);\n		font-family: Pretendard;\n		font-size: 32px;\n		font-style: normal;\n		font-weight: 800;\n		line-height: 130%; /* 41.6px */\n		letter-spacing: -1.28px;\n	}\n\n	.desc {\n		color: var(--desc-gray);\n		text-align: center;\n		font-family: Pretendard;\n		font-size: 20px;\n		font-style: normal;\n		font-weight: 500;\n		line-height: 150%; /* 30px */\n		letter-spacing: -0.8px;\n		width: 100%;\n	}\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	min-width: 300px;\n	width: calc(50% - 20px);\n	.name {\n		color: var(--card-bg);\n		font-family: Pretendard;\n		font-size: 32px;\n		font-style: normal;\n		font-weight: 700;\n		line-height: 150%; /* 48px */\n		letter-spacing: -1.28px;\n	}\n\n	.position {\n		color: var(--card-bg);\n		font-size: 20px;\n		font-style: normal;\n		font-weight: 500;\n		line-height: 150%; /* 30px */\n		letter-spacing: -0.8px;\n	}\n\n	.desc {\n		color: var(--desc-gray);\n		font-family: Pretendard;\n		font-size: 20px;\n		font-style: normal;\n		font-weight: 500;\n		line-height: 150%; /* 30px */\n		letter-spacing: -0.8px;\n	}\n\n	.img {\n		width: 100%;\n	}\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}




var AboutContents = function() {
    var a = 1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainContentsContainer, {
        className: "column-center-start",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TrustSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OurJourneySection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CofounderSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ruix/* Empty */.HY, {
                space: 220
            })
        ]
    });
};
var MainSection = function() {
    var a = 1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentsContainer, {
        style: {
            padding: "88px 40px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ruix/* GroupA */.so, {
            order: "column-start-start",
            gap: 72,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ruix/* GroupA */.so, {
                    order: "column-start-start",
                    gap: 20,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MainTitle, {
                            children: "원포인트의 본질은\n매칭도 고용도 아닙니다"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MainSubTitle, {
                            children: "신뢰입니다"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ruix/* GroupA */.so, {
                    order: "column-start-start",
                    gap: 40,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ruix/* GroupA */.so, {
                            order: "column-start-start",
                            gap: 12,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MainDescription, {
                                    children: "세상에는 잠재력 높은 작은 기업이 너무 많습니다\n좋은 인재와 함께 한다면 빠르게 성장할 수 있는데, 현실적으로 어렵습니다"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MainDescription, {
                                    children: "저희 롸잇은 어렵지만 너무 중요한 이 문제를 해결하고 싶고,\n검증된 인재를 파트타임으로 고용할 수 있게 돕는 것이 그 시작입니다"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MainSubDescription, {
                            children: "외부 인재와의 협업이기 때문에 조심스러울 수 밖에 없습니다\n조금이라도 더 마음편히 고용하고, 성장하실 수 있도록 저희 팀 매일 정진하겠습니다"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MainDescriptionTitle, {
                            children: "신뢰를 최우선시 하겠습니다\n항상 올바른 가치를 추구하고 정직하게 일하겠습니다"
                        })
                    ]
                })
            ]
        })
    });
};
var MainTitle = emotion_styled_browser_esm/* default.h1 */.Z.h1(_templateObject());
var MainSubTitle = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject1());
var MainDescription = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject2());
var MainSubDescription = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject3());
var MainDescriptionTitle = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject4());
var TrustSection = function() {
    var a = 1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentsContainer, {
        className: "column-start-start",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleDiv, {
                children: "주요 성과"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ruix/* Empty */.HY, {
                space: 20
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ruix/* GroupA */.so, {
                order: "row-start-start",
                gap: 8,
                children: TrustData.map(function(data, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TrustCard, {
                        className: "column-center-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "title",
                                children: data.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ruix/* GroupA */.so, {
                                order: "row-center-center",
                                gap: 0,
                                fullWidth: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "num",
                                        children: data.num
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "numstr",
                                        children: data.numstr
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "desc",
                                children: data.dest
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};
var TitleDiv = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject5());
var OurJourneySection = function() {
    var a = 1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentsContainer, {
        className: "column-start-start",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleDiv, {
                children: "걸어온 길"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ruix/* Empty */.HY, {
                space: 20
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ruix/* GroupA */.so, {
                fullWidth: true,
                order: "row-start-between",
                gap: 20,
                children: [
                    JourneyData.map(function(data, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(JourneyCard, {
                            className: "column-start-start",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(WebpImage/* default */.Z, {
                                    width: 16,
                                    height: 16,
                                    src: "/onepoint/images/renewal/about/ellipse.png"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "year",
                                    children: data.year
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ruix/* GroupA */.so, {
                                    order: "column-start-start",
                                    gap: 0,
                                    children: data.monthData.map(function(monthData, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "row-start-start",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "month",
                                                    children: [
                                                        monthData.month,
                                                        "월"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "title",
                                                    children: monthData.title
                                                })
                                            ]
                                        }, index);
                                    })
                                })
                            ]
                        }, index);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LineJourney, {})
                ]
            })
        ]
    });
};
var CofounderSection = function() {
    var a = 1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentsContainer, {
        className: "column-start-start",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleDiv, {
                children: "만든 사람"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ruix/* Empty */.HY, {
                space: 20
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ruix/* GroupA */.so, {
                order: "row-center-between",
                gap: 40,
                children: CofounderData.map(function(data, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CofounderCard, {
                        className: "column-start-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "img",
                                style: {
                                    aspectRatio: "1/1",
                                    objectFit: "cover"
                                },
                                src: data.image
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ruix/* Empty */.HY, {
                                space: 20
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "name",
                                children: data.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "position",
                                children: data.position
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ruix/* Empty */.HY, {
                                space: 12
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "desc",
                                children: data.school
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ruix/* Empty */.HY, {
                                space: 12
                            }),
                            data.career.map(function(career, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "desc",
                                    children: career
                                }, index);
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};
var ContentsContainer = emotion_styled_browser_esm/* default.section */.Z.section(_templateObject6());
var MainContentsContainer = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject7());
var LineJourney = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject8());
var JourneyCard = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject9());
var TrustCard = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject10());
var TrustData = [
    {
        title: "누적 고객사",
        num: "500+",
        numstr: "개",
        dest: "전문가를 1회 이상 고용한 고객사 수"
    },
    {
        title: "누적 전문가",
        num: "700+",
        numstr: "명",
        dest: "3단계 검증을 거쳐 합격한 전문가 수"
    },
    {
        title: "계약 연장",
        num: "80",
        numstr: "%",
        dest: "매월 계약을 연장하는 기업의 비율"
    }, 
];
var JourneyData = [
    {
        year: "2022",
        monthData: [
            {
                month: 7,
                title: "법인 설립"
            },
            {
                month: 8,
                title: "시드 투자"
            },
            {
                month: 11,
                title: "업무 스코핑 컨설팅 도입"
            }, 
        ]
    },
    {
        year: "2023",
        monthData: [
            {
                month: 5,
                title: "TIPS 선정"
            },
            {
                month: 7,
                title: "전문가 교육 시스템 구축"
            },
            {
                month: 8,
                title: "지원자 동료평가 시스템 구축"
            },
            {
                month: 12,
                title: "최적매칭 VQ 시스템화"
            }, 
        ]
    },
    {
        year: "2024",
        monthData: [
            {
                month: 5,
                title: "최적 매칭 알고리즘 고도화"
            },
            {
                month: 8,
                title: "전문가 검증 자동화 솔루션\n도입"
            }, 
        ]
    }, 
];
var CofounderData = [
    {
        name: "최준순",
        position: "Co-Founder&CEO",
        school: "연세대학교 졸업",
        career: [
            "前 AT커니 컨설턴트",
            "前 인터브랜드 컨설턴트"
        ],
        image: "/onepoint/images/renewal/about/junsoon.png"
    }, 
];
var CofounderCard = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject11());

;// CONCATENATED MODULE: ./src/component/home/renewal/about/AboutPage.tsx





var AboutPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainLayout/* MainLayout */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainGnb/* MainGnb */.F, {
                type: "none"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutContents, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainFooter/* MainFooter */.j, {})
        ]
    });
};
/* harmony default export */ var about_AboutPage = (AboutPage);

// EXTERNAL MODULE: ./src/component/home/renewal/main/mobile/MainFooterMobile.tsx
var MainFooterMobile = __webpack_require__(40191);
// EXTERNAL MODULE: ./src/component/home/renewal/main/mobile/MainGnbMobile.tsx + 1 modules
var MainGnbMobile = __webpack_require__(43775);
;// CONCATENATED MODULE: ./src/component/home/renewal/about/mobile/AboutContentsMobile.tsx

function AboutContentsMobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	gap: 80px;\n"
    ]);
    AboutContentsMobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AboutContentsMobile_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 100%;\n	max-width: 768px;\n	padding: 0 10px;\n	position: relative;\n"
    ]);
    AboutContentsMobile_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function AboutContentsMobile_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	color: var(--card-bg);\n	font-family: Pretendard;\n	font-size: 32px;\n	font-style: normal;\n	font-weight: 800;\n	line-height: 116%;\n	letter-spacing: -1.6px;\n	margin: 0;\n\n	@media (min-width: 600px) {\n		font-size: 40px;\n	}\n"
    ]);
    AboutContentsMobile_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function AboutContentsMobile_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-family: Pretendard;\n	font-size: 64px;\n	font-style: normal;\n	font-weight: 800;\n	line-height: 116%;\n	letter-spacing: -2.88px;\n\n	@media (min-width: 600px) {\n		font-size: 72px;\n	}\n"
    ]);
    AboutContentsMobile_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function AboutContentsMobile_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	color: var(--desc-gray);\n	font-family: Pretendard;\n	font-size: 16px;\n	font-style: normal;\n	font-weight: 500;\n	line-height: 150%;\n	letter-spacing: -0.8px;\n	word-break: keep-all;\n	overflow-wrap: break-word;\n\n	@media (min-width: 600px) {\n		font-size: 20px;\n		padding: 0 12px;\n	}\n"
    ]);
    AboutContentsMobile_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function AboutContentsMobile_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	color: var(--desc-gray);\n	font-family: Pretendard;\n	font-size: 20px;\n	font-style: normal;\n	font-weight: 700;\n	line-height: 150%;\n	letter-spacing: -0.96px;\n	word-break: keep-all;\n	overflow-wrap: break-word;\n\n	@media (min-width: 600px) {\n		font-size: 24px;\n		padding: 0 12px;\n	}\n"
    ]);
    AboutContentsMobile_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function AboutContentsMobile_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	color: var(--card-bg);\n	font-family: Pretendard;\n	font-size: 28px;\n	font-style: normal;\n	font-weight: 700;\n	line-height: 130%;\n	letter-spacing: -1.2px;\n	word-break: keep-all;\n	overflow-wrap: break-word;\n\n	@media (min-width: 600px) {\n		font-size: 40px;\n		padding: 0 12px;\n	}\n"
    ]);
    AboutContentsMobile_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function AboutContentsMobile_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	color: var(--card-bg);\n	font-family: Pretendard;\n	font-size: 32px;\n	font-style: normal;\n	font-weight: 800;\n	line-height: 120%; /* 48px */\n	letter-spacing: -1.6px;\n\n	@media (min-width: 600px) {\n		font-size: 40px;\n	}\n"
    ]);
    AboutContentsMobile_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function AboutContentsMobile_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	width: 320px;\n	padding: 40px 20px;\n	flex-direction: column;\n	align-items: flex-start;\n	gap: 10px;\n	border-radius: 4px;\n	background: #f8f9fb;\n\n	.title {\n		color: var(--desc-gray);\n		text-align: center;\n		font-family: Pretendard;\n		font-size: 20px;\n		font-style: normal;\n		font-weight: 700;\n		line-height: 150%; /* 36px */\n		letter-spacing: -0.96px;\n		width: 100%;\n	}\n\n	.num {\n		color: var(--card-bg);\n		font-family: Pretendard;\n		font-size: 40px;\n		font-style: normal;\n		font-weight: 800;\n		line-height: 116%; /* 55.68px */\n		letter-spacing: -1.92px;\n	}\n\n	.numstr {\n		color: var(--card-bg);\n		font-family: Pretendard;\n		font-size: 24px;\n		font-style: normal;\n		font-weight: 800;\n		line-height: 130%; /* 41.6px */\n		letter-spacing: -1.28px;\n	}\n\n	.desc {\n		color: var(--desc-gray);\n		text-align: center;\n		font-family: Pretendard;\n		font-size: 16px;\n		font-style: normal;\n		font-weight: 500;\n		line-height: 150%; /* 30px */\n		letter-spacing: -0.8px;\n		width: 100%;\n	}\n\n	@media (min-width: 600px) {\n		.title {\n			font-size: 24px;\n		}\n\n		.num {\n			font-size: 48px;\n		}\n\n		.numstr {\n			font-size: 32px;\n		}\n\n		.desc {\n			font-size: 20px;\n		}\n	}\n"
    ]);
    AboutContentsMobile_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function AboutContentsMobile_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: column;\n	justify-content: center;\n	align-items: center;\n	gap: 20px;\n\n	.card {\n		display: flex;\n		flex-direction: column;\n		justify-content: center;\n		align-items: center;\n		gap: 20px;\n	}\n\n	.year {\n		color: var(--card-bg);\n		font-family: Pretendard;\n		font-size: 24px;\n		font-style: normal;\n		font-weight: 800;\n		line-height: 130%; /* 41.6px */\n		letter-spacing: -1.28px;\n		padding-top: 4px;\n	}\n\n	.month {\n		color: var(--card-bg);\n		font-family: Pretendard;\n		font-size: 16px;\n		font-style: normal;\n		font-weight: 700;\n		line-height: 150%; /* 30px */\n		letter-spacing: -0.8px;\n		margin-right: 16px;\n		width: 3ch;\n		text-align: right;\n	}\n\n	.title {\n		color: var(--desc-gray);\n		font-family: Pretendard;\n		font-size: 16px;\n		font-style: normal;\n		font-weight: 500;\n		line-height: 150%;\n		letter-spacing: -0.8px;\n	}\n\n	.month-data {\n		width: 230px;\n	}\n\n	.line-0,\n	.line-1 {\n		width: 110%;\n		height: 4px;\n		flex-shrink: 0;\n		background: #f8f9fb;\n	}\n\n	@media (min-width: 600px) {\n		.card {\n			display: flex;\n			flex-direction: row;\n			align-items: start;\n			justify-content: start;\n			width: 385px;\n		}\n\n		.year {\n			padding-top: 0;\n			font-size: 32px;\n		}\n\n		.month {\n			font-size: 20px;\n		}\n\n		.title {\n			font-size: 20px;\n		}\n\n		.month-data {\n			width: 100%;\n		}\n	}\n"
    ]);
    AboutContentsMobile_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function AboutContentsMobile_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	min-width: 300px;\n	width: calc(50% - 20px);\n\n	.name {\n		color: var(--card-bg);\n		font-family: Pretendard;\n		font-size: 24px;\n		font-style: normal;\n		font-weight: 700;\n		line-height: 150%;\n		letter-spacing: -1.28px;\n	}\n\n	.position {\n		color: var(--card-bg);\n		font-size: 16px;\n		font-style: normal;\n		font-weight: 500;\n		line-height: 150%;\n		letter-spacing: -0.8px;\n	}\n\n	.desc {\n		color: var(--desc-gray);\n		font-family: Pretendard;\n		font-size: 16px;\n		font-style: normal;\n		font-weight: 500;\n		line-height: 150%;\n		letter-spacing: -0.8px;\n	}\n\n	.img {\n		width: 100%;\n	}\n\n	@media (min-width: 600px) {\n		.name {\n			font-size: 32px;\n		}\n\n		.position {\n			font-size: 20px;\n		}\n\n		.desc {\n			font-size: 20px;\n		}\n	}\n"
    ]);
    AboutContentsMobile_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}



var AboutContentsMobile = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AboutContentsMobile_MainContentsContainer, {
        className: "column-center-start",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutContentsMobile_MainSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutContentsMobile_TrustSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutContentsMobile_OurJourneySection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutContentsMobile_CofounderSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ruix/* Empty */.HY, {
                space: 12
            })
        ]
    });
};
var AboutContentsMobile_MainContentsContainer = emotion_styled_browser_esm/* default.div */.Z.div(AboutContentsMobile_templateObject());
var AboutContentsMobile_ContentsContainer = emotion_styled_browser_esm/* default.section */.Z.section(AboutContentsMobile_templateObject1());
var AboutContentsMobile_MainSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutContentsMobile_ContentsContainer, {
        className: "column-center-start",
        style: {
            padding: "60px 20px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ruix/* GroupA */.so, {
            order: "column-start-start",
            gap: 40,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ruix/* GroupA */.so, {
                    order: "column-start-start",
                    gap: 10,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutContentsMobile_MainTitle, {
                            children: "원포인트의 본질은\n매칭도 고용도 아닙니다"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutContentsMobile_MainSubTitle, {
                            children: "신뢰입니다"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ruix/* GroupA */.so, {
                    order: "column-start-start",
                    gap: 20,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ruix/* GroupA */.so, {
                            order: "column-start-start",
                            gap: 12,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutContentsMobile_MainDescription, {
                                    children: "세상에는 잠재력 높은 작은 기업이 너무 많습니다\n좋은 인재와 함께 한다면 빠르게 성장할 수 있는데, 현실적으로 어렵습니다"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutContentsMobile_MainDescription, {
                                    children: "저희 롸잇은 어렵지만 너무 중요한 이 문제를 해결하고 싶고,\n검증된 인재를 파트타임으로 고용할 수 있게 돕는 것이 그 시작입니다"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutContentsMobile_MainSubDescription, {
                            children: "외부 인재와의 협업이기 때문에 조심스러울 수 밖에 없습니다\n조금이라도 더 마음편히 고용하고, 성장하실 수 있도록 저희 팀 매일 정진하겠습니다"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutContentsMobile_MainDescriptionTitle, {
                            children: "신뢰를 최우선시 하겠습니다\n항상 올바른 가치를 추구하고 정직하게 일하겠습니다"
                        })
                    ]
                })
            ]
        })
    });
};
var AboutContentsMobile_MainTitle = emotion_styled_browser_esm/* default.h1 */.Z.h1(AboutContentsMobile_templateObject2());
var AboutContentsMobile_MainSubTitle = emotion_styled_browser_esm/* default.div */.Z.div(AboutContentsMobile_templateObject3());
var AboutContentsMobile_MainDescription = emotion_styled_browser_esm/* default.div */.Z.div(AboutContentsMobile_templateObject4());
var AboutContentsMobile_MainSubDescription = emotion_styled_browser_esm/* default.div */.Z.div(AboutContentsMobile_templateObject5());
var AboutContentsMobile_MainDescriptionTitle = emotion_styled_browser_esm/* default.div */.Z.div(AboutContentsMobile_templateObject6());
var AboutContentsMobile_TrustSection = function() {
    var TrustData = [
        {
            title: "누적 고객사",
            num: "500+",
            numstr: "개",
            dest: "전문가를 1회 이상 고용한 고객사 수"
        },
        {
            title: "누적 전문가",
            num: "700+",
            numstr: "명",
            dest: "3단계 검증을 거쳐 합격한 전문가 수"
        },
        {
            title: "계약 연장",
            num: "80",
            numstr: "%",
            dest: "매월 계약을 연장하는 기업의 비율"
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AboutContentsMobile_ContentsContainer, {
        className: "column-center-start",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutContentsMobile_TitleDiv, {
                children: "주요 성과"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ruix/* Empty */.HY, {
                space: 24
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ruix/* GroupA */.so, {
                order: "row-start-center",
                gap: 8,
                children: TrustData.map(function(data, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AboutContentsMobile_TrustCard, {
                        className: "column-center-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "title",
                                children: data.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ruix/* GroupA */.so, {
                                order: "row-center-center",
                                gap: 0,
                                fullWidth: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "num",
                                        children: data.num
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "numstr",
                                        children: data.numstr
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "desc",
                                children: data.dest
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};
var AboutContentsMobile_TitleDiv = emotion_styled_browser_esm/* default.div */.Z.div(AboutContentsMobile_templateObject7());
var AboutContentsMobile_TrustCard = emotion_styled_browser_esm/* default.div */.Z.div(AboutContentsMobile_templateObject8());
var AboutContentsMobile_OurJourneySection = function() {
    var JourneyData = [
        {
            year: "2022",
            monthData: [
                {
                    month: 7,
                    title: "법인 설립"
                },
                {
                    month: 8,
                    title: "시드 투자"
                },
                {
                    month: 11,
                    title: "업무 스코핑 컨설팅 도입"
                }, 
            ]
        },
        {
            year: "2023",
            monthData: [
                {
                    month: 5,
                    title: "TIPS 선정"
                },
                {
                    month: 7,
                    title: "전문가 교육 시스템 구축"
                },
                {
                    month: 8,
                    title: "지원자 동료평가 시스템 구축"
                },
                {
                    month: 12,
                    title: "최적매칭 VQ 시스템화"
                }, 
            ]
        },
        {
            year: "2024",
            monthData: [
                {
                    month: 5,
                    title: "최적 매칭 알고리즘 고도화"
                },
                {
                    month: 8,
                    title: "전문가 검증 자동화 솔루션 도입"
                }, 
            ]
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AboutContentsMobile_ContentsContainer, {
        className: "column-center-start",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutContentsMobile_TitleDiv, {
                children: "걸어온 길"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ruix/* Empty */.HY, {
                space: 24
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ruix/* GroupA */.so, {
                fullWidth: true,
                order: "column-center-start",
                gap: 32,
                children: JourneyData.map(function(data, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AboutContentsMobile_JourneyCard, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "card",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "year",
                                        children: data.year
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ruix/* GroupA */.so, {
                                        order: "column-start-start",
                                        gap: 0,
                                        children: data.monthData.map(function(monthData, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "row-start-start month-data",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "month",
                                                        children: [
                                                            monthData.month,
                                                            "월"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "title",
                                                        children: monthData.title
                                                    })
                                                ]
                                            }, index);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "line-".concat(index)
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};
var AboutContentsMobile_JourneyCard = emotion_styled_browser_esm/* default.div */.Z.div(AboutContentsMobile_templateObject9());
var AboutContentsMobile_CofounderSection = function() {
    var CofounderData = [
        {
            name: "최준순",
            position: "Co-Founder&CEO",
            school: "연세대학교 졸업",
            career: [
                "前 AT커니 컨설턴트",
                "前 인터브랜드 컨설턴트"
            ],
            image: "/onepoint/images/renewal/about/junsoon.png"
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AboutContentsMobile_ContentsContainer, {
        className: "column-center-start",
        style: {
            padding: "0 32px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutContentsMobile_TitleDiv, {
                children: "만든 사람"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ruix/* Empty */.HY, {
                space: 24
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ruix/* GroupA */.so, {
                order: "row-start-center",
                gap: 40,
                children: CofounderData.map(function(data, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AboutContentsMobile_CofounderCard, {
                        className: "column-start-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "img",
                                style: {
                                    aspectRatio: "1/1",
                                    objectFit: "cover"
                                },
                                src: data.image
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ruix/* Empty */.HY, {
                                space: 20
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "name",
                                children: data.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "position",
                                children: data.position
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ruix/* Empty */.HY, {
                                space: 12
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "desc",
                                children: data.school
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ruix/* Empty */.HY, {
                                space: 12
                            }),
                            data.career.map(function(career, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "desc",
                                    children: career
                                }, index);
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};
var AboutContentsMobile_CofounderCard = emotion_styled_browser_esm/* default.div */.Z.div(AboutContentsMobile_templateObject10());

;// CONCATENATED MODULE: ./src/component/home/renewal/about/mobile/AboutPageMobile.tsx





var AboutPageMobile = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainLayout/* MainLayout */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainGnbMobile/* MainGnbMobile */.j, {
                type: "none"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutContentsMobile, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainFooterMobile/* MainFooterMobile */.w, {})
        ]
    });
};
/* harmony default export */ var mobile_AboutPageMobile = (AboutPageMobile);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./pages/about.tsx




var About = function(props) {
    var ref = (0,react.useState)(props.isPc), isPc = ref[0], setIsPc = ref[1];
    (0,react.useEffect)(function() {
        var handleResize = function() {
            if (window.innerWidth >= 1024) {
                setIsPc(true);
            } else {
                setIsPc(false);
            }
        };
        window.addEventListener("resize", handleResize);
        handleResize();
        return function() {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isPc ? /*#__PURE__*/ (0,jsx_runtime.jsx)(about_AboutPage, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_AboutPageMobile, {})
    });
};
/* harmony default export */ var about = (About);


/***/ }),

/***/ 76445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);




var WebpImage = function(props) {
    var src = props.src;
    var isSvg = src.endsWith(".svg");
    var webpSrc = src.replace("/onepoint/", "/webp-onepoint/").replace(/\.(png|jpg|jpeg)$/, ".webp");
    var loading = props.loading, alt = props.alt, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props, [
        "loading",
        "alt"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("picture", {
        style: {
            display: "flex",
            flexShrink: 0
        },
        children: [
            !isSvg && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                srcSet: webpSrc,
                type: "image/webp"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, rest), {
                loading: loading || "lazy",
                alt: alt || src
            }))
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (WebpImage);


/***/ }),

/***/ 57386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Is": function() { return /* binding */ makePhoneNumber; },
/* harmony export */   "Ks": function() { return /* binding */ makePhoneNumberV2; },
/* harmony export */   "a$": function() { return /* binding */ validatePhone; },
/* harmony export */   "df": function() { return /* binding */ validatePhone2; },
/* harmony export */   "oH": function() { return /* binding */ validateEmail; }
/* harmony export */ });
function validateEmail(email) {
    return String(email).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
}
function validatePhone(phone, isNotKorea) {
    if (isNotKorea) return true;
    return phone.length === 10 && phone.startsWith("10");
// const patternPhone = new RegExp("1[016789]-[^0][0-9]{2,3}-[0-9]{3,4}");
// if (patternPhone.test(phone)) {
// 	return true;
// }
// return false;
}
function validatePhone2(phone) {
    return phone.startsWith("010");
}
function makePhoneNumber(value) {
    var result = value;
    if (result.includes("-")) result = result.replace(/-/gi, "");
    if (result.length === 11 && result.startsWith("010")) return result.slice(1);
    return result;
}
function makePhoneNumberV2(value) {
    var result = value;
    if (result.includes("-")) result = result.replace(/-/gi, "");
    return result;
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3978,1272,9774,2888,179], function() { return __webpack_exec__(39212); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);